module.exports = __webpack_public_path__ + "img/md-mail.4fd2289a.svg";